import {Vector3} from 'three'

import {CORNER_RADIUS} from '../modules/cube/_config'

const basePosition = new Vector3(0, 0, 0)

const calcPosition = (pos: Vector3) => {
  pos.add(basePosition)
  pos.x *= 1.0 + CORNER_RADIUS * 1.1
  pos.y *= 1.0 + CORNER_RADIUS * 1.1
  pos.z *= 1.0 + CORNER_RADIUS * 1.1

  return pos
}

const offsetStart = {
  position: new Vector3(-10, 0, 0),
  rotation: new Vector3(0, 0, 0),
}

const centerDelay = 0.5
const centerDuration = 5

export default [
  {
    position: calcPosition(new Vector3(-3, 1, 0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'mosaic',
    isGlassRender: false,
    offsetStart,
    delay: 0.0,
    duration: 3,
    scale: 1,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(-3, 0, -1)),
    rotation: new Vector3(Math.PI * 0.5, 0, 0),
    cubeType: 'normal',
    isGlassRender: false,
    offsetStart,
    delay: 0.1,
    duration: 3,
    scale: 1,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
  // center
  {
    position: calcPosition(new Vector3(0, 0, 0)),
    rotation: new Vector3(Math.PI * 0.5, 0, 0),
    cubeType: 'invertocat',
    isGlassRender: false,
    offsetStart,
    delay: centerDelay,
    duration: centerDuration,
    scale: 1,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
  // center
  {
    position: calcPosition(new Vector3(-1.5, 0, 0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'glassNoBlur',
    isGlassRender: false,
    offsetStart,
    delay: centerDelay,
    duration: centerDuration,
    scale: new Vector3(1.92, 1, 1),
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(-3, -1, 0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'whiteGreen',
    isGlassRender: false,
    offsetStart,
    delay: 0.3,
    duration: 4,
    scale: 1,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(-3, 0, 1)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'glassRainbowNoBlur',
    isGlassRender: false,
    offsetStart,
    delay: 0.1,
    duration: 4,
    scale: 1,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
]
